import { cn } from '~/style';

export const Section = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div className={cn('mx-auto max-w-8xl px-6 md:px-8 lg:px-20', className)}>
      {children}
    </div>
  );
};
